import { create } from '@stylexjs/stylex';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';

/** Compose base, invalid (when applicable), then disabled. Components own layout and native semantics. */
export const controlStyles = create({
  base: {
    borderStyle: 'solid',
    borderWidth: controlMetrics.borderWidth,
    borderColor: {
      'default': colors.border,
      ':hover': colors.borderHover,
      ':focus': colors.borderFocus,
      ':focus-within': colors.borderFocus,
      ':active': colors.borderActive,
    },
    backgroundColor: colors.background,
    color: colors.text,
  },
  invalid: {
    borderColor: {
      'default': colors.borderInvalid,
      ':hover': colors.borderInvalid,
      ':focus': colors.borderInvalid,
      ':focus-within': colors.borderInvalid,
      ':active': colors.borderInvalid,
    },
  },
  disabled: {
    borderColor: {
      'default': colors.borderDisabled,
      ':hover': colors.borderDisabled,
      ':focus': colors.borderDisabled,
      ':focus-within': colors.borderDisabled,
      ':active': colors.borderDisabled,
    },
    backgroundColor: colors.backgroundDisabled,
    color: colors.textDisabled,
    cursor: 'not-allowed',
  },
});
